export default __webpack_public_path__ + "img/eXQKoenm.2dfa0689.svg";